const intialState = {
  allClients:[
    { id:1 , name:"Company 1" , vendors:5 , subText:"Incomplete" },
    { id:2 , name:"Company 2" , vendors:3 , subText:"Complete" }
  ]
}

export default (state = intialState , action ) => {  
    return state;
}